module.exports = __webpack_public_path__ + "static/media/NT_HongHau.9ccd0586.jpg";